export type Staff = { id: string; name: string; email: string; role: "admin" | "sales" };

export type Activity = { type: string; text: string; by?: string; at: string };

export type Lead = {
  id: string;
  name: string;
  company: string;
  phone: string;
  email: string;
  address: string;
  location: string;
  work_type: string;
  area_sqm: string;
  message: string;
  source_page: string;
  utm: Record<string, string>;
  status: Status;
  owner_id: string | null;
  follow_up_at: string | null;
  follow_up_note: string;
  duplicate_of: string | null;
  site_visit_requested: boolean;
  site_visit_date: string;
  site_visit_slot: string;
  attachments: { id: string; filename: string; size: number; content_type: string }[];
  gcal?: { user_id?: string | null; follow_up?: string; site_visit?: string };
  created_at: string;
  activities?: Activity[];
  related?: { id: string; name: string; work_type: string; status: Status; created_at: string; is_original: boolean }[];
};

export const STATUSES = ["new", "contacted", "quoted", "won", "lost"] as const;
export type Status = (typeof STATUSES)[number];

export const STATUS_STYLE: Record<Status, string> = {
  new: "bg-blue-500/15 text-blue-300 border-blue-500/40",
  contacted: "bg-violet-500/15 text-violet-300 border-violet-500/40",
  quoted: "bg-yellow-500/15 text-yellow-300 border-yellow-500/40",
  won: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  lost: "bg-red-500/15 text-red-300 border-red-500/40",
};

export const fmtDate = (s: string | null) =>
  s ? new Date(s).toLocaleString("en-AU", { day: "2-digit", month: "short", hour: "numeric", minute: "2-digit" }) : "—";

export const isOverdue = (l: Lead) => !!l.follow_up_at && new Date(l.follow_up_at) < new Date() && !["won", "lost"].includes(l.status);
